
const vFilter = {
  thumbnailImg: url => {
    if (!url) return 'http://appletstatic.qn.xiaohebook.com/book-default-cover.png'
    return url.indexOf('?') === -1 ? url + '?imageView2/0/w/270/q/100' : url + '&imageView2/0/w/270/q/100'
  }
}

export default vFilter
